import React from "react";
import { AutoComplete, Empty, Spin, Table } from "antd";

function VehicleDropDown({ CarOptions, fetchCarOptions, setCarOptions, handleSelect, loading }) {
    const DropDownColumns = [
        {
            title: "Vehicle",
            dataIndex: "vehicle",
            key: "vehicle",
        },
        {
            title: "Year",
            dataIndex: "year",
            key: "year",
        },
        {
            title: "Model",
            dataIndex: "product",
            key: "product",
        },
        {
            title: "Type",
            dataIndex: "vehicle_type",
            key: "vehicle_type",
        },
        {
            title: "Lot#",
            dataIndex: "lot_number",
            key: "lot_number",
        },
        {
            title: "Chassis#",
            dataIndex: "chasis_no",
            key: "chasis_no",
        },

        {
            title: "Title",
            dataIndex: "title",
            key: "title",
        },
        {
            title: "Customer",
            dataIndex: "customer_name",
            key: "customer_name",
        },
    ];

    return (
        <AutoComplete
            options={[]}
            onSearch={(query) => fetchCarOptions(query, setCarOptions)}
            onSelect={(value, option) => handleSelect(value, option)}
            placeholder="Search and select a car"
            notFoundContent={loading ? <Spin size="small" /> : <Empty description="No results" />}

            dropdownRender={(menu) => (
                <div style={{ padding: 8, background: "#fff", borderRadius: 6, maxWidth: "100%", maxHeight: 300, overflow: "auto" }}>
                    {loading ? (
                        <div style={{ textAlign: "center", padding: 40 }}>
                            <Spin size="large" />
                        </div>
                    ) : (
                        <Table
                            columns={DropDownColumns}
                            dataSource={CarOptions?.map((item, index) => ({
                                key: index,
                                ...item.data,
                            }))}
                            scroll={{ y: 200 }}
                            pagination={false}
                            onRow={(record) => ({
                                onClick: () => {
                                    const selectedCarValue = `${record.vehicle} || ${record.chasis_no} || ${record.year} || ${record.container_no} || ${record.customer_name}`;
                                    handleSelect(selectedCarValue, { data: record });
                                },
                            })}
                        />
                    )}
                </div>
            )}
        />
    )
}

export default VehicleDropDown
